import React from 'react';
import { useSelector } from 'react-redux';

import { selectIsOrderFlagged } from '../../../../state/selectors/orderFlags';
import { setOrderFlags } from '../../../../gql/services/orderFlags';
import { useFlagScopeTexts } from '../../../../hooks/useFlagScopeTexts';
import { FlagIcon } from './FlagIcon';
import { FlagButton } from './FlagToggleButton.styles';

/**
 * Botón interruptor de la bandera de una orden.
 *
 * 🔴 La fila (`DoubleTapRow`) escucha `onClick`, `onTouchStart` y `onTouchEnd`,
 * y en el `touchend` hace `preventDefault()` (anula el click sintético). Si el
 * botón solo cortara `onClick`, en tablet el toque llegaría a la fila, la
 * seleccionaría y no marcaría nada. Por eso se corta en los tres eventos y la
 * acción se dispara SOLO desde `onClick`, para no marcar dos veces.
 */
export const FlagToggleButton = ({
  orderId,
}: {
  orderId: string;
}): JSX.Element => {
  const flagged = useSelector(selectIsOrderFlagged(orderId));
  const { toggle: label } = useFlagScopeTexts();

  return (
    <FlagButton
      type="button"
      $flagged={flagged}
      aria-pressed={flagged}
      aria-label={label}
      title={label}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        void setOrderFlags([orderId], !flagged);
      }}
      onTouchStart={(e: React.TouchEvent) => e.stopPropagation()}
      onTouchEnd={(e: React.TouchEvent) => e.stopPropagation()}
    >
      <FlagIcon filled={flagged} />
    </FlagButton>
  );
};
